import { TextField, Grid, IconButton, Typography, Button } from "@mui/material";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import { AddCircle, RemoveCircle } from "@mui/icons-material";

export default function OrganisationSicherheitForm() {
  const { control } = useFormContext();

  const { fields: softwareFields, append: appendSoftware, remove: removeSoftware } = useFieldArray({
    control,
    name: "softwareList"
  });

  const { fields: hardwareFields, append: appendHardware, remove: removeHardware } = useFieldArray({
    control,
    name: "hardwareList"
  });

  const { fields: zertifikatFields, append: appendZertifikat, remove: removeZertifikat } = useFieldArray({
    control,
    name: "certificates"
  });

  return (
    <Grid container spacing={3} direction="column">
      <Grid item xs={12}>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
      Technische Infrastruktur: Software, Hardware und Speichermedien
              </Typography>
        <Typography variant="h6">Eingesetzte Software</Typography>
        <Typography variant="body1" gutterBottom>
        Hinweis: Bitte geben Sie hier das Datum an, seit dem Sie die Software nutzen (z. B. Installationsdatum oder Umstellungsdatum auf ein neues System). Unter "Details" sind Name der Software, Versionsnummer, Hersteller sowie ggf. die Umgebung (z. B. Windows-Server, Cloud-Dienst etc.) zu dokumentieren.

        
      
        </Typography>
      </Grid>

      {softwareFields.map((item, index) => (
        <Grid item xs={12} key={item.id}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Seit wann wird die Software genutzt?
              </Typography>
              <Controller
                name={`softwareList.${index}.startDate`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} label="Seit (Datum)" type="date" InputLabelProps={{ shrink: true }} fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Details zur Software (Name, Version, Hersteller, Umgebung)
              </Typography>
              <Controller
                name={`softwareList.${index}.details`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} label="Details" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "right" }}>
              <IconButton color="error" onClick={() => removeSoftware(index)}>
                <RemoveCircle />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Button
          startIcon={<AddCircle />}
          variant="outlined"
          onClick={() => appendSoftware({ startDate: "", details: "" })}
        >
          Software hinzufügen
        </Button>
      </Grid>

      <Grid item xs={12} sx={{ mt: 4 }}>
        <Typography variant="h6">Eingesetzte Hardware</Typography>
        <Typography variant="body1" gutterBottom>
          Hinweis: Bitte geben Sie hier das Datum an, seit dem Sie die Hardware nutzen (z. B. Anschaffungsdatum oder Inbetriebnahmedatum). Unter "Details" sind Name der Hardware, Modell, Hersteller sowie ggf. die Spezifikationen (z. B. Prozessor, RAM, Speicher etc.) zu dokumentieren.
        </Typography>
      </Grid>

      {hardwareFields.map((item, index) => (
        <Grid item xs={12} key={item.id}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Seit wann wird die Hardware genutzt?
              </Typography>
              <Controller
                name={`hardwareList.${index}.startDate`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} label="Seit (Datum)" type="date" InputLabelProps={{ shrink: true }} fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Details zur Hardware (Name, Modell, Hersteller, Spezifikationen)
              </Typography>
              <Controller
                name={`hardwareList.${index}.details`}
                control={control}
                render={({ field }) => (
                  <TextField {...field} label="Details" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "right" }}>
              <IconButton color="error" onClick={() => removeHardware(index)}>
                <RemoveCircle />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Button
          startIcon={<AddCircle />}
          variant="outlined"
          onClick={() => appendHardware({ startDate: "", details: "" })}
        >
          Hardware hinzufügen
        </Button>
      </Grid>

      <Grid item xs={12} sx={{ mt: 4 }}>
        <Typography variant="subtitle2" gutterBottom>
          Speichermedium (z. B. Server, Cloud-Speicher):
           Bitte geben Sie hier das Speichermedium an, auf dem die digitalen und digitalisierten Belege abgelegt werden (z. B. Server, Cloud-Speicher, externe Festplatte).
        </Typography>
        <Controller
          name="storageMedium"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Speichermedium" fullWidth />
          )}
        />
      </Grid>
    </Grid>
  );
}
